import {
	Component,
	IComponentBindings,
	IComponentOptions,
	IQuerySuccessEventArgs,
	Initialization,
	IQueryOptions,
	QueryEvents,
	OmniboxEvents
} from 'coveo-search-ui';
import * as $ from "jquery";
import * as _ from "underscore";

export class SuggestionList extends Component {
	static ID = "SuggestionList";
	public numberOfResults: number;
	private template: any;
	private titleField: string;

	constructor(public element: HTMLElement, public options: IQueryOptions, public bindings: IComponentBindings) {
		super(element, SuggestionList.ID, bindings);
		this.numberOfResults = parseInt(this.element.getAttribute("data-number-of-results"), 10);
		this.titleField = Coveo.TemplateHelpers.getHelper("coveoFieldName")("titlefordisplay");
		this.template = _.template($("script.result-template", this.element).html().trim());

		this.bind.onRootElement(OmniboxEvents.populateOmnibox, (args) => this.populateOmniboxResultList(args));
		this.bindEnterToSearchButton();
	}

	// The enter button stops working when calling "queryController.createQueryBuilder(options);" in the populateOmnibox event.
	// This ugly workaround fixes the enter button.
	bindEnterToSearchButton() {
		var $coveoWrapper = $(this.element).siblings(".CoveoSearchbox"),
			$searchbox = $coveoWrapper.find("input"),
			$searchBtn = $coveoWrapper.find(".CoveoSearchButton");

		$searchbox.on("keyup", function (event) {
			if (event.keyCode === 13) {
				$searchBtn.click();
			}
		});
	}

	buildOmniboxContent(results) {
		var $omnibox = $("<div></div>");

		results.forEach((result) => {
			var html = this.template({ clickUri: result.clickUri, titlefordisplay: result.raw[this.titleField] });
			$omnibox.append(html);
		});
		return $omnibox[0];
	}

	populateOmniboxResultList (populateOmniboxObject) {
		var queryBuilder = this.queryController.createQueryBuilder(this.options);
		queryBuilder.numberOfResults = this.numberOfResults;
		var query = queryBuilder.build();

		var promise = this.executeSearchQuery(query).then((response) => {
			var resultElement;
			if (response.totalCount > 0) {
				return { element: this.buildOmniboxContent(response.results) };
			}

			return { element: undefined };
		});

		populateOmniboxObject.rows.push({ deferred: promise });
	}

	executeSearchQuery (query) {
		return Coveo.SearchEndpoint.endpoints["default"].search(query);
	}
}

Initialization.registerAutoCreateComponent(SuggestionList);



// WEBPACK FOOTER //
// ./src/source/Atlas.SEF.Feature.Common/Areas/AtlasCommon/Assets/Search/components/SuggestionList.ts